/*
  Semaine — Meno Belly cold-traffic LP behaviors.

  Lives in assets/ instead of inline because Shopify's admin theme editor
  silently strips inline <script> blocks from section markup during roundtrips
  (per CLAUDE.md). External asset references via script_tag survive.

  Behaviors:
    1. Smooth-scroll for any [data-scroll-to="<element-id>"] click.
    2. Mobile-only sticky ATC bar that appears after the hero scrolls off and
       hides while the buy box is in view (avoids double-CTA).
    3. Guarded window.fireEvent analytics on view + primary-CTA clicks.

  Globals are always guarded with `typeof window.X === 'function'` so a missing
  analytics layer can't break the rest of the page (per CLAUDE.md).
*/

(function () {
  'use strict';

  var ROOT_SELECTOR = '.lp-mbl';
  var STICKY_ID = 'lp-mbl-sticky';
  var BUY_ID = 'lp-mbl-shop';
  var HERO_SELECTOR = '.lp-mbl__hero';
  var MOBILE_MAX = 749;
  var HEADER_OFFSET = 80;

  function safeFireEvent(name, payload) {
    if (typeof window.fireEvent === 'function') {
      try { window.fireEvent(name, payload || {}); } catch (err) { /* swallow */ }
    }
  }

  function smoothScrollTo(el) {
    var rect = el.getBoundingClientRect();
    var top = window.pageYOffset + rect.top - HEADER_OFFSET;
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      window.scrollTo(0, top);
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scroll-to]');
    if (!trigger) return;
    var targetId = trigger.getAttribute('data-scroll-to');
    if (!targetId) return;
    var target = document.getElementById(targetId);
    if (!target) return;
    e.preventDefault();
    smoothScrollTo(target);
    safeFireEvent('lp_meno_belly_cta_click', {
      cta: targetId,
      label: (trigger.textContent || '').trim().slice(0, 60)
    });
  });

  function initStickyBar() {
    var section = document.querySelector(ROOT_SELECTOR);
    if (!section) return;
    var hero = section.querySelector(HERO_SELECTOR);
    var buy = document.getElementById(BUY_ID);
    var sticky = document.getElementById(STICKY_ID);
    if (!hero || !buy || !sticky) return;

    var hidden = true;
    function setHidden(next) {
      if (next === hidden) return;
      hidden = next;
      sticky.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    }

    function update() {
      if (window.innerWidth > MOBILE_MAX) {
        setHidden(true);
        return;
      }
      var heroBottom = hero.getBoundingClientRect().bottom;
      var buyRect = buy.getBoundingClientRect();
      var pastHero = heroBottom < HEADER_OFFSET;
      var buyInView = buyRect.top < window.innerHeight && buyRect.bottom > 0;
      setHidden(!(pastHero && !buyInView));
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initBundleAtcEvents() {
    var bundleForm = document.querySelector('.lp-mbl [data-bundle-atc]');
    if (!bundleForm) return;
    bundleForm.addEventListener('submit', function () {
      safeFireEvent('lp_meno_belly_bundle_atc', {});
    });
  }

  function initReviewsCarousel() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    var reviewCards = root.querySelectorAll('.lp-mbl__review-card');
    reviewCards.forEach(function (card) {
      var video = card.querySelector('.lp-mbl__review-card-video');
      var playBtn = card.querySelector('.lp-mbl__review-card-play');
      if (!video || !playBtn) return;

      var startPlay = function () {
        reviewCards.forEach(function (other) {
          if (other === card) return;
          var otherVideo = other.querySelector('.lp-mbl__review-card-video');
          if (otherVideo && !otherVideo.paused) {
            otherVideo.pause();
            other.classList.remove('is-playing');
            otherVideo.controls = false;
          }
        });
        video.controls = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
        card.classList.add('is-playing');
      };

      playBtn.addEventListener('click', startPlay);
      video.addEventListener('play', function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
        video.controls = false;
      });
    });

    var reviewsTrack = root.querySelector('.lp-mbl__reviews-track');
    var reviewsPrev = root.querySelector('.lp-mbl__reviews-nav--prev');
    var reviewsNext = root.querySelector('.lp-mbl__reviews-nav--next');
    if (reviewsTrack && reviewsPrev && reviewsNext) {
      var scrollByCard = function (direction) {
        var card = reviewsTrack.querySelector('.lp-mbl__review-card');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 20;
        reviewsTrack.scrollBy({ left: step * direction, behavior: 'smooth' });
      };
      reviewsPrev.addEventListener('click', function () { scrollByCard(-1); });
      reviewsNext.addEventListener('click', function () { scrollByCard(1); });
    }
  }

  function initProductGallery() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    var galleryThumbs = root.querySelectorAll('.lp-product__thumb');
    var galleryPrimaries = root.querySelectorAll('.lp-product__primary-img');
    var galleryMedia = root.querySelector('.lp-product__media');
    var galleryPrimary = root.querySelector('.lp-product__primary');
    var galleryActiveIdx = 0;
    if (!galleryPrimaries.length) return;

    function setGalleryActive(idx) {
      if (idx < 0 || idx >= galleryPrimaries.length) return;
      galleryActiveIdx = idx;
      galleryThumbs.forEach(function (t) {
        var match = parseInt(t.getAttribute('data-thumb-index'), 10) === idx;
        t.classList.toggle('lp-product__thumb--active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        if (match && t.scrollIntoView) {
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
      galleryPrimaries.forEach(function (img) {
        img.setAttribute('data-active', parseInt(img.getAttribute('data-thumb-index'), 10) === idx ? 'true' : 'false');
      });
      if (galleryMedia) {
        galleryMedia.classList.toggle('lp-product__media--secondary', idx !== 0);
      }
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setGalleryActive(parseInt(thumb.getAttribute('data-thumb-index'), 10));
      });
    });

    if (galleryPrimary && galleryPrimaries.length > 1) {
      var swipeStartX = 0, swipeStartY = 0, swipeStartTime = 0, swipeActive = false;
      var SWIPE_DIST = 40;   // min horizontal px to count as a swipe
      var SWIPE_TIME = 600;  // max ms (slower = a slow drag, ignore)
      galleryPrimary.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        swipeStartX = e.clientX;
        swipeStartY = e.clientY;
        swipeStartTime = Date.now();
        swipeActive = true;
      });
      galleryPrimary.addEventListener('pointerup', function (e) {
        if (!swipeActive) return;
        swipeActive = false;
        var dx = e.clientX - swipeStartX;
        var dy = e.clientY - swipeStartY;
        var dt = Date.now() - swipeStartTime;
        if (Math.abs(dx) >= SWIPE_DIST && Math.abs(dx) > Math.abs(dy) && dt < SWIPE_TIME) {
          setGalleryActive(galleryActiveIdx + (dx < 0 ? 1 : -1));
        }
      });
      galleryPrimary.addEventListener('pointercancel', function () { swipeActive = false; });
      galleryPrimary.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }

  // Clinical-proof stat numbers count up from 0 when scrolled into view.
  // Targets are parsed from each element's final text (e.g. "90%" -> 90, "%"),
  // so the editor can change the numbers without touching JS. Respects
  // prefers-reduced-motion and degrades to the static final value when the
  // browser lacks IntersectionObserver / rAF.
  function initStatCountup() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var stats = root.querySelectorAll('.lp-mbl__proof-stat[data-countup]');
    if (!stats.length) return;

    var items = [];
    stats.forEach(function (el) {
      var finalText = (el.textContent || '').trim();
      var match = finalText.match(/-?\d+(?:\.\d+)?/);
      if (!match) return; // non-numeric stat: leave untouched
      var num = match[0];
      items.push({
        el: el,
        target: parseFloat(num),
        prefix: finalText.slice(0, match.index),
        suffix: finalText.slice(match.index + num.length),
        decimals: (num.split('.')[1] || '').length,
        finalText: finalText,
        done: false
      });
    });
    if (!items.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window) || !window.requestAnimationFrame) {
      return; // final values already in the DOM; skip animation
    }

    var DURATION = 1400;
    function render(item, value) {
      item.el.textContent = item.prefix + value.toFixed(item.decimals) + item.suffix;
    }
    function animate(item) {
      if (item.done) return;
      item.done = true;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / DURATION, 1);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        render(item, item.target * eased);
        if (p < 1) {
          window.requestAnimationFrame(step);
        } else {
          item.el.textContent = item.finalText; // exact final text, no rounding drift
        }
      }
      window.requestAnimationFrame(step);
    }

    items.forEach(function (item) { render(item, 0); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        for (var i = 0; i < items.length; i++) {
          if (items[i].el === entry.target) { animate(items[i]); break; }
        }
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    items.forEach(function (item) { observer.observe(item.el); });
  }

  // Timeline progress rail: the ::after fill grows from 0 to full height once
  // the timeline scrolls into view (CSS transition driven by the .is-visible
  // class). If IntersectionObserver is missing, mark visible immediately so the
  // fill still shows.
  function initTimelineProgress() {
    var timeline = document.querySelector(ROOT_SELECTOR + ' .lp-mbl__timeline');
    if (!timeline) return;
    if (!('IntersectionObserver' in window)) {
      timeline.classList.add('is-visible');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.25 });
    observer.observe(timeline);
  }

  function init() {
    if (!document.querySelector(ROOT_SELECTOR)) return;
    initStickyBar();
    initBundleAtcEvents();
    initReviewsCarousel();
    initProductGallery();
    initStatCountup();
    initTimelineProgress();
    safeFireEvent('lp_meno_belly_view', { path: window.location.pathname });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
